import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'app-confirm-reenvio-dialog',
  templateUrl: './modal-reenvio-soportes.component.html'
})
export class ModalReenvioComponent {

  constructor(
    public dialogRef: MatDialogRef<ModalReenvioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  cancelar() {
    this.dialogRef.close(false);
  }

  confirmar() {
    this.dialogRef.close(true);
  }
}